import React, { Suspense } from 'react';
import { Layout, Spin } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { useDarkMode } from 'src/context/DarkModeContext';
import Title from 'antd/es/typography/Title';
import ScrollToTopButton from '../ScrollToTopButton';

type PageStructureProps = {
    Page: React.ReactNode;
    TitleNode: React.ReactNode;
};

const PageStructureComponent: React.FC<PageStructureProps> = ({ Page, TitleNode }) => {
    const { isDarkMode } = useDarkMode();

    return (
        <Layout id="page" className={isDarkMode ? 'dark' : 'light'}>
            <Content className="page-content">
                <Title className="page-title" level={2}>
                    {TitleNode}
                </Title>
                {Page}
            </Content>
        </Layout>
    );
};

// Lazy wrapper
const LazyPageStructure = React.lazy(() =>
    Promise.resolve({ default: PageStructureComponent })
);

// Suspense-wrapped export
const PageStructure: React.FC<PageStructureProps> = (props) => (
    <Suspense
        fallback={
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                }}
            >
                <Spin size="large" />
            </div>
        }
    >
        <LazyPageStructure {...props} />
        <ScrollToTopButton />

    </Suspense>
);

export default PageStructure;
